import React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Box from '@mui/material/Box';
import FAQ from '../pages/FAQ';

export default function InfoModal({ open, onClose, openQuestion }) {
    return (
        <Dialog open={open} onClose={onClose} fullWidth maxWidth="md" PaperProps={{ sx: { bgcolor: 'background.default' } }}>
            <DialogTitle>
                FAQ
                <IconButton aria-label="close" onClick={onClose} sx={{ position: 'absolute', right: 8, top: 8 }}>
                    <CloseIcon />
                </IconButton>
            </DialogTitle>
            <DialogContent dividers>
                <Box sx={{ minHeight: 200 }}><FAQ openQuestion={openQuestion} /></Box>
            </DialogContent>
        </Dialog>
    );
}
